<template lang="pug">
  v-app
    navbarbeforelogin(
    )
      h3 {{ title }}  
    v-main
      router-view 
    footer-login
    button(v-if="agentInfo && Object.keys(agentInfo).length > 0" class="chat-agent" @click="openChat")
      IconChat(class="icon-chat")

    LiveChatWidget(
      v-if="agentInfo.live_chat_key"
      :license="agentInfo.live_chat_key"
      visibility="hidden"
      v-on:visibility-changed="onVisibilityChanged"
    )

    dialog-anonymous-contact-agent(ref="dialogAnonymousContactAgent")
    
</template>

<script>
import navbarbeforelogin from '@/components/AppBar/NavbarBeforeLogin-v2'
import dialogAnonymousContactAgent from '@/components/Dialog/DialogAnonymousContactAgent'
import FooterLogin from '@/components/Footer/FooterLogin'
import IconChat from '@/components/Icon/IconChat.vue'
import { LiveChatWidget } from '@livechat/widget-vue/v2'
import { anonymous as apiAnonymous } from '@/apis'  

import {
  ROUTE_LOGIN,
  ROUTE_OTP,
  ROUTE_RESET_PASSWORD
} from '@/const/route'

export default {
  name: "App",  
  components: {
    navbarbeforelogin,
    dialogAnonymousContactAgent,
    FooterLogin,
    IconChat,
    LiveChatWidget
  },
  data: () => ({   
    agentInfo: {},
  }), 
  computed : {
    pathName () {
      return this.$route.name
    }, 

    title () {
      return this.pathName === ROUTE_LOGIN ? 'เข้าสู่ระบบ' : 
      this.pathName === ROUTE_OTP ? 'เตรียมยืนยันรหัส OTP ผ่านโทรศัพท์' : 
      this.pathName === ROUTE_RESET_PASSWORD ? 'ยืนยัน OTP เพื่อรีเซ็ทรหัสผ่าน' : null
    }
  },
  async created () {
    await this.getAgentInfo()
  },
  methods: {
    async getAgentInfo (){
      const [err, data] = await apiAnonymous.getAgentInfo({ domain: window.location.host })
      
      if (err) {
        return
      }     
      this.agentInfo = data 
    },
    onVisibilityChanged (event) {
      switch (event.visibility) {
        case "maximized":
          break;
        case "minimized":
          window.LC_API.hide_chat_window();
          break;
        case "hidden":
          break;
      }
    },
    openChat () {
      this.$refs.dialogAnonymousContactAgent.open()
    }
  } 
};
</script> 